import { useEffect } from "react";

const TidioChatbot = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "//code.tidio.co/ozzfx203gub2smttllwrusqmcekfikqx.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            // Cleanup: Remove the script when component unmounts
            document.body.removeChild(script);
        };
    }, []);

    return null;
};

export default TidioChatbot;
